import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';
import { BookeventMissiondoneLinkDTO } from '../dto/BookeventDTOs';

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
`;

const Input = styled.input`
  width: 90%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  color: #222;
  background: #fff;
  transition: border-color 0.2s;
  
  &:focus {
    outline: none;
    border-color: #007AFF;
  }
  
  &::placeholder {
    color: #bbb;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

const Button = styled.button`
  flex: 1;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
`;

const CancelButton = styled(Button)`
  background: #f5f5f7;
  color: #666;
  
  &:hover {
    background: #e5e5e7;
  }
`;

const SaveButton = styled(Button)`
  background: #007AFF;
  color: white;
  
  &:hover {
    background: #0056CC;
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export default function MissionDoneLinkInput({ 
  missionTypes = [], 
  missiondoneLinks = [],
  onSave, 
  onClose 
}) {
  const [linkUrls, setLinkUrls] = useState({});

  useEffect(() => {
    
    const missiondoneLinkMap = {};
    console.log("missiondoneLinks", missiondoneLinks);
    missiondoneLinks &&missiondoneLinks.forEach(missiondoneLink => {
      if (missiondoneLink.missiondoneTypeId) {
        missiondoneLinkMap[missiondoneLink.missiondoneTypeId] = missiondoneLink.linkUrl;
      }
    });// missionTypes가 변경될 때마다 linkUrls 초기화

    const initialUrls = {};
    missionTypes.forEach(missionType => {
      if (missionType.id) {
        initialUrls[missionType.id] = missiondoneLinkMap[missionType.id] || '';
      }
    });
    setLinkUrls(initialUrls); 
  }, [missionTypes, missiondoneLinks]);

  const handleInputChange = (missionTypeId, value) => {
    setLinkUrls(prev => ({
      ...prev,
      [missionTypeId]: value
    }));
  };

  const handleSave = () => {
    const linkData = missionTypes
      .filter(missionType => missionType.id && linkUrls[missionType.id])
      .map(missionType => ({
        missiondoneTypeId: missionType.id,
        linkUrl: linkUrls[missionType.id]
      }));

    if (onSave) {
      onSave(linkData);
    }
  };

  const hasValidInputs = missionTypes.some(missionType => 
    missionType.id   // && linkUrls[missionType.id]?.trim()
  );

  return (
    <Modal>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>링크 제출</ModalTitle>
          <CloseButton onClick={onClose}>
            <FaTimes />
          </CloseButton>
        </ModalHeader>
        
        {missionTypes.map(missionType => (
          <FormGroup key={missionType.id}>
            <Label>{missionType.typeName}</Label>
            <Input
              type="text"
              placeholder={`${missionType.typeName} 링크를 입력해주세요`}
              value={linkUrls[missionType.id] || ''}
              onChange={(e) => handleInputChange(missionType.id, e.target.value)}
            />
          </FormGroup>
        ))}
        
        <ButtonRow>
          <CancelButton onClick={onClose}>
            취소
          </CancelButton>
          <SaveButton 
            onClick={handleSave}
            disabled={!hasValidInputs}
          >
            저장
          </SaveButton>
        </ButtonRow>
      </ModalContent>
    </Modal>
  );
}
